import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { MTabGroupAlignment } from './MTabGroup.types';

const { spacers, border } = baseVariables;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const TabContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  border-block-end: ${border.borderWidth02} ${border.borderStyleDefault} var(--t-horizontal-vertical-rule, #c4c4c4);
`;

export const SwiperWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  padding-block-start: ${toRem(4)};
  padding-inline: ${toRem(4)};

  .swiper {
    width: 100%;
    overflow: visible;
  }

  .swiper-slide {
    width: auto;
    flex-shrink: 0;

    &:not(:last-child) {
      margin-inline-end: ${spacers?.spacers?.[4] ?? '1.5rem'};
    }
  }
`;

export const ScrollControl = styled.div<{ $side: 'start' | 'end' }>`
  position: absolute;
  top: 0;
  bottom: 0;
  ${({ $side }) => ($side === 'start' ? 'inset-inline-start: 0;' : 'inset-inline-end: 0;')}
  display: flex;
  align-items: center;
`;

export const PanelArea = styled.div<{ $hidden?: boolean; $alignment?: MTabGroupAlignment }>`
  inline-size: 100%;
  padding-block-start: ${spacers?.spacers?.[3] ?? '1rem'};
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
  ${({ $alignment }) =>
    $alignment === MTabGroupAlignment.Centered &&
    `
    text-align: center;
  `}
`;
